const baseURL = "https://www.miniso.com.mx/";

export const MenuNuevo = [
  {
    text:'Lo más Nuevo',
    url:`${baseURL}lo-nuevo`
  },
  {
    text:'Blind Box 🧸',
    url:`${baseURL}blind-box`
  },
  {
    text:'Tiktoker 🔥',
    url:`${baseURL}tecnologia/tiktok`
  },
  {
    text:'Linea Gamer 🎮 👾',
    url:`${baseURL}linea-gamer`
  },
  {
    text:'Navidad 🎄🎅',
    url:`${baseURL}navidad`
  },
  {
    text:'Invierno 🌲❄️',
    url:`${baseURL}invierno`
  },
  {
    text:' Dia de Reyes 🧝‍♂️',
    url:`${baseURL}dia-de-reyes`
  },
];

export const MenuCuenta = [
  {
    text:'Mi Cuenta',
    url:`${baseURL}account#/profile`
  },
  {
    text:'Mis Pedidos',
    url:`${baseURL}account#/orders`
  },
  {
    text:'Formas de Pago',
    url:`${baseURL}formas-de-pago`
  },
  {
    text:'Devoluciones y Garantias',
    url:`${baseURL}devoluciones-y-garantias`,
    noLG: true
  },
  {
    text:'Preguntas Frecuentes',
    url:`${baseURL}faq`
  },
  {
    text:'Opciones de Entrega',
    url:`${baseURL}opciones-de-entrega`,
    noLG: true
  },
  {
    text:'Terminos de las Promociones',
    url:`${baseURL}terminos-de-promociones`
  },
  {
    text:'Ayuda en Compra, Personal Shopper',
    url:`${baseURL}ayuda-personal-shopper`
  },
];

export const MenuDevol = [
  {
    text:'Devoluciones y Garantias',
    url:`${baseURL}devoluciones-y-garantias`,
  },
  {
    text:'Opciones de Entrega',
    url:`${baseURL}opciones-de-entrega`,
  },
  {
    text:'Terminos de Devoluciones',
    url:`${baseURL}devoluciones-y-garantias`,
  },
];

export const MenuMiniApp = [
  {
    text:'Miniso APP 📱',
    url:`${baseURL}miniso-app`
  },
  {
    text:'Trabaja con Nosotros',
    url:`https://www.linkedin.com/company/miniso-mexico/`
  },
  {
    text:'Facturacion',
    url:`${baseURL}facturacion`
  },
  {
    text:'Tiendas',
    url:`${baseURL}tiendas`
  },
  {
    text:'Contáctanos',
    url:`${baseURL}contactanos`
  },
  {
    text:'Marketplaces',
    url:`${baseURL}contactanos`
  },
];

export const MenuRedes = [
  {
    text:'Facebook',
    url:`https://www.facebook.com/MinisoMexico/`
  },
  {
    text:'Instagram',
    url:`https://www.instagram.com/minisomexico/`
  },
  {
    text:'Twitter',
    url:`https://twitter.com/MinisoMexico`
  },
  {
    text:'Youtube',
    url:`https://www.youtube.com/channel/UCij39FzpeoB81opYs2GAPQQ`
  },
  {
    text:'Tiktok',
    url:`https://www.miniso.com.mx/Tiktok`
  },
];